import { useEffect, useState } from "react";
import axios from "axios";
import { Star } from "lucide-react";
import { log } from "../../utils/logger";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Renders nothing until at least 5 real ratings exist — never fabricated.
export default function RatingsBadge({ className = "" }) {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    axios.get(`${API}/ratings/summary`).then(({ data }) => setSummary(data)).catch((err) => log.warn("ratings summary failed", err));
  }, []);

  if (!summary?.show) return null;
  const full = Math.round(summary.average);

  return (
    <span data-testid="ratings-badge" className={`inline-flex items-center gap-1.5 ${className}`} title={`${summary.average} out of 5 from ${summary.count} founders who finished the guide`}>
      <span className="flex items-center" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((n) => (
          <Star key={n} className={`h-3.5 w-3.5 ${n <= full ? "fill-[#F5B301] text-[#F5B301]" : "text-[var(--c-muted)]/40"}`} />
        ))}
      </span>
      <span className="font-bold text-[var(--c-text)]">{summary.average}</span>
      <span>from {summary.count} finishers</span>
    </span>
  );
}
